import {boardPrintout} from "@/components/BoardPrintouts";
import {ToolboxButton} from "@/components/navbar/toolbox/ToolboxButton";
import FeatureFlag from "@/server/com/silkplm/rpc/FeatureFlag";
import ProductWCLElements from "@/server/com/silkplm/model/plm/ProductWCLElements";
import FormsLoader from "@/components/forms/FormsLoader";


export function getCustomToolboxMixinsForList(listClass, entitiesListInstance, selectedItem = null) {
    // TODO BoardTemplate Feture flaga - najlepiej do toolboxa, a tu tylko posanie ID flagi

    let toolboxButtonList = [];
    if (listClass.formClass === "ProductInSeasonColorVersionView") {
        if (SessionManager.hasFlag(FeatureFlag.BOARD_TEMPLATE)) {

            toolboxButtonList.push(new ToolboxButton().withIcon("fa-duotone print").withLabel($tr("toolboxButton.BoardPrintout", "Board Printout")).
                //withGroup("demo").
                withAction(() => boardPrintout(entitiesListInstance))
            )
        }
    }
    // if (listClass.formClass === "OrderDetails" && !entitiesListInstance.form) {
    //         toolboxButtonList.push(new ToolboxButton().withIcon("tag").withLabel("Branding Settings")
    //             .withText("Branding Settings").withCustomClass("bg-primary text-light").
    //             withAction(async ()=> {
    //                 let product = new ProductInSeason();
    //                 console.log(entitiesListInstance.form);
    //                 await product.load(entitiesListInstance.form.fields["productInSeasonId"].value);
    //                 let wcl = await product.getProductWCLElements();
    //                 await FormsLoader.showForm(ProductWCLElements, {
    //                     mode: 'EDIT',
    //                     entityId: wcl.id})}
    //             )
    //         );
    // }
    // else if (listClass.formClass === "OrderDetails" && entitiesListInstance.form) {
    //     toolboxButtonList.push(new ToolboxButton().withIcon("tag").withLabel("Branding Settings").withDisabled(true)
    //         .withText("Branding Settings").withCustomClass("bg-primary text-light").
    //         withAction(async ()=> {
    //             let product = new ProductInSeason();
    //             console.log(entitiesListInstance.form);
    //             await product.load(entitiesListInstance.form.fields["productInSeasonId"].value);
    //             let wcl = await product.getProductWCLElements();
    //             await FormsLoader.showForm(ProductWCLElements, {
    //                 mode: 'EDIT',
    //                 entityId: wcl.id})}
    //         )
    //     );
    // }

    return toolboxButtonList;
}